import React, { useEffect, useCallback } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { apiService } from '../../services/apiClient';
import { apiUrl } from '../../services/apiUrl';
import uiConfig from '../../config/uiConfig';

const COLORS = uiConfig.chartPalette || ["#008FFB", "#00E396", "#FEB019", "#669DB5", "#94A74A", "#93C3EE", "#E5C6A0"];

const PieChats = ({ data, selectedCategory, onCategoryChange, showLegend = true, chartType = "donut" }) => {

  const effectiveCategory = (selectedCategory && data && data[selectedCategory])
    ? selectedCategory
    : (data && Object.keys(data).length > 0 ? Object.keys(data)[0] : null);

  const GetUserReportList = useCallback(async () => {
    if (!effectiveCategory) return;
    const userGroupId = data[effectiveCategory]?.id;
    if (!userGroupId) return;
    try {
      await apiService.get(apiUrl.aipdUserReportListByGroup(userGroupId));
    } catch (err) {
      console.error("Error:", err);
    }
  }, [effectiveCategory, data]);

  useEffect(() => {
    GetUserReportList();
  }, [GetUserReportList]);

  if (!data || Object.keys(data).length === 0 || !effectiveCategory) return null;

  const selectedChartData = data[effectiveCategory]?.chats?.[0];

  const chartData = selectedChartData?.XAxis?.map((label, i) => ({
    name: label,
    value: selectedChartData?.YAxis?.[i] ?? 0,
  }));

  return (
    <div>
      {chartData && chartData.length > 0 && (
        <ResponsiveContainer width="100%" height={290}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={chartType === "pie" ? 0 : 55}
              outerRadius={90}
              dataKey="value"
            >
              {chartData.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(value, name) => [value, name]} />
            {showLegend && <Legend layout="horizontal" verticalAlign="bottom" align="center" wrapperStyle={{ fontSize: "11px", paddingTop: "8px" }} />}
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default PieChats;
